// LangSwitcher — a compact 5-language picker. Chosen language is stored in
// localStorage and returned through a callback so the parent can refetch.

import { SUPPORTED_LANGS, LANG_LABELS, type Lang } from '@/lib/api'

interface Props {
  value: Lang
  onChange: (lang: Lang) => void
  className?: string
}

export function LangSwitcher({ value, onChange, className }: Props) {
  return (
    <div
      role="group"
      aria-label="Interview language"
      className={`inline-flex flex-wrap items-center gap-1 text-xs ${className ?? ''}`}
    >
      {SUPPORTED_LANGS.map((lang) => {
        const active = lang === value
        return (
          <button
            key={lang}
            type="button"
            onClick={() => onChange(lang)}
            className={
              'px-2 py-0.5 rounded-full border transition-colors ' +
              (active
                ? 'bg-vermillion text-white border-vermillion'
                : 'bg-transparent text-muted-foreground border-black/10 hover:border-black/30')
            }
          >
            {LANG_LABELS[lang]}
          </button>
        )
      })}
    </div>
  )
}

export default LangSwitcher
